// extracted by mini-css-extract-plugin
export default {"alert":"TimedAlert_alert__1hQRr","float-wrapper":"TimedAlert_float-wrapper__FC3Zr","float":"TimedAlert_float__yFbb3"};